// extracted by mini-css-extract-plugin
export var card = "EmotionalCruiseCard-module--card--1dfc0";
export var cardDarker = "EmotionalCruiseCard-module--cardDarker--ffe19";
export var container = "EmotionalCruiseCard-module--container--8e728";
export var cta = "EmotionalCruiseCard-module--cta--9e062";
export var expeditionIcon = "EmotionalCruiseCard-module--expedition-icon--dda5c";
export var footer = "EmotionalCruiseCard-module--footer--bf249";
export var footerContent = "EmotionalCruiseCard-module--footerContent--3549a";
export var headerContent = "EmotionalCruiseCard-module--header-content--3e6b2";
export var imageContainer = "EmotionalCruiseCard-module--image-container--04c5b";
export var info = "EmotionalCruiseCard-module--info--343f9";
export var price = "EmotionalCruiseCard-module--price--c69f4";
export var shipIcon = "EmotionalCruiseCard-module--ship-icon--6dfd0";
export var shipInfo = "EmotionalCruiseCard-module--ship-info--2c91f";
export var trip = "EmotionalCruiseCard-module--trip--b7b6a";